import React from 'react';
import { FullTable } from 'components';
import { ReportsBody, ReportsHead, ReportsNotYet } from './constants';
import { sortListByKey, useModal } from 'utils';
import { clientReportEnums, GenerateReport, staffReportEnums } from './core';
import { useSelector } from 'react-redux';

export const StaffReports = ({}) => {
    const { open } = useModal();
    const company = useSelector((state) => state.system.company);

    const openGenerate = (item) => {
        open(<GenerateReport info={item?.generateInfo} />);
    };

    return (
        <div>
            <FullTable
                head={ReportsHead}
                body={ReportsBody(openGenerate)}
                list={sortListByKey(
                    staffReportEnums(company)?.filter((i) => i?.id),
                    'name'
                )}
                notYet={ReportsNotYet('Staff')}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
